module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAASCAYAAACAa1QyAAABCElEQVQokY3SsStFURwH8A/eoIfFn2AyiAEZZJGwkXr1RLIZDAZZ7DaTUihRSGK0UIwiNwzEalRGeUpheOfWFe/e9607nLqfe7/nd05NFEXnaMY4HlWRWtSjA1cYqxYN4gBNOMIS6rLQW6i2gC8s4jhUrojgG8sYwiuGcY32NBTnDF24RQsuUMxC8Ixe7KAB+6FFLg1BCVOYwyfmcYLONBRnBQN4QT8izGQhuMFlYj2ahdqUpziifDSbKOZSwDRWkcc9Cnji/z3lsRWePLbREwMSYwxpxWGo9Y7ZgH4liSawhsbw1UKo9SfxLV/HbgB76K4E4j+dog8fyoe5UenlJCrhAZO4ywLwAxESN2sUqdCOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_dy.png
// module id = f2Kk
// module chunks = 39